/**
 * @file
 */

import bbox from '@turf/bbox';
import {
  createGeometry,
  belgiumBounds,
  mapboxAccessToken,
} from '../../../../themes/custom/didtheme/src/utils/MapUtils';

(($, Drupal, mapboxgl) => {
  Drupal.behaviors.mapsInit = {
    attach(context, settings) {
      if (!$('#map', context).length) {
        return;
      }

      const geometry = [];

      for (let i = 0; i < settings.maps.length; i++) {
        geometry.push(createGeometry(settings.maps[i]));
      }

      mapboxgl.accessToken = mapboxAccessToken;
      let mapStartCoordinates = [4.399246, 51.082206];
      if (geometry[0].type === 'MultiPolygon') {
        [[[mapStartCoordinates]]] = geometry[0].coordinates;
      } else if (geometry[0].type === 'Polygon') {
        [[mapStartCoordinates]] = geometry[0].coordinates;
      }

      const map = new mapboxgl.Map({
        container: 'map',
        style:
          'mapbox://styles/didmapboxfrederik/ciz02ulow00032rnsyzqba92c?optimize=true',
        center: mapStartCoordinates,
        zoom: 10,
        maxBounds: belgiumBounds,
        interactive: false,
        attributionControl: true,
      });

      let mapSource;
      const features = [];
      for (let i = 0; i < geometry.length; i++) {
        features.push({
          type: 'Feature',
          properties: {},
          geometry: geometry[i],
        });
      }
      map.on('load', () => {
        mapSource = {
          type: 'FeatureCollection',
          features,
        };

        const boundingBox = bbox(mapSource);
        map.fitBounds(boundingBox, { linear: true, padding: 20, duration: 0 });

        map.addSource('route', {
          type: 'geojson',
          data: mapSource,
        });
        map.addLayer({
          id: 'route',
          type: 'fill',
          source: 'route',
          paint: {
            'fill-color': '#FF6E00',
            'fill-opacity': 0.5,
            'fill-outline-color': '#FF6E00',
          },
        });
      });

      const createPhaseMap = (index, element) => {
        const elementTop = $(element).offset().top;
        const screenBottom = $(window).scrollTop() + window.innerHeight;
        if (screenBottom > elementTop && !$(element).hasClass('inview')) {
          // The element is visible, do something.
          $(element).addClass('inview');
          $(element).addClass('hasmap');
          const mapId = `phasemap_${index}`;
          const phasejson = $(element).data('maps-json');
          $(element).append(
            `<div class="content--timeline-map" id="${mapId}"></div>`,
          );

          const phaseGeometry = createGeometry(phasejson);
          if (phaseGeometry.type === 'MultiPolygon') {
            [[[mapStartCoordinates]]] = phaseGeometry.coordinates;
          } else if (phaseGeometry.type === 'Polygon') {
            [[mapStartCoordinates]] = phaseGeometry.coordinates;
          }
          const phaseMap = new mapboxgl.Map({
            container: mapId,
            style:
              'mapbox://styles/didmapboxfrederik/ciz02ulow00032rnsyzqba92c?optimize=true',
            center: mapStartCoordinates,
            zoom: 10,
            maxBounds: belgiumBounds,
            interactive: false,
            attributionControl: false,
          });

          const phaseMapSource = {
            type: 'FeatureCollection',
            features: [
              {
                type: 'Feature',
                properties: {},
                geometry: phaseGeometry,
              },
            ],
          };

          const boundingBox = bbox(phaseMapSource);
          phaseMap.fitBounds(boundingBox, {
            linear: true,
            padding: 20,
            duration: 0,
            maxZoom: 16,
          });

          phaseMap.on('load', () => {
            phaseMap.addSource(`phaseroute_${index}`, {
              type: 'geojson',
              data: phaseMapSource,
            });

            phaseMap.addLayer({
              id: `phaseroute_${index}`,
              type: 'fill',
              source: `phaseroute_${index}`,
              paint: {
                'fill-color': '#FF6E00',
                'fill-opacity': 0.5,
                'fill-outline-color': '#FF6E00',
              },
            });
          });
        }
      };

      $(window).scroll(() => {
        $('.content--timeline .content--timeline-item[data-maps-json]').each(
          createPhaseMap,
        );
      });
    },
  };
})(jQuery, Drupal, mapboxgl);
